import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import ipfs from 'decentralized/Ipfs.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import WallpaperContract from 'decentralized/contracts/WallpaperContract.js';
import {NewWallpaper} from 'decentralized/EthereumEvents.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {WALLPAPER} from 'decentralized/transactions/contracts.js';

const contractAddress = new WallpaperContract().contractAddress;

export const newWallpaper = async (hash) => {
    
    let thumb = await getThumbnail(hash);
    console.log('thumb = ', thumb);
    await new EthereumTransaction(
        WALLPAPER,
        'newWallpaper',
        [
            ipfsHashToBytes32(hash),
            ipfsHashToBytes32(thumb),
        ])
        .execute();
};

export const getWallpapers = async (hash) => {
    let query =  new BackendQuery(
        contractAddress)
        .from(NewWallpaper)
        .select("wallpaperHash")
        .select("thumbnailHash");

    if (hash) {
        query.where("wallpaperHash", hash);
    }

    let results = await query.executeQuery();

    let thumbToFull = {};
    for (let result of results) {
        thumbToFull[result.thumbnailHash] = result.wallpaperHash;
    }
    let wallpapers = [];
    for (let thumb in thumbToFull) {
        wallpapers.push(
            {
                wallpaper: thumbToFull[thumb],
                thumbnail : thumb
            });
    }
    return wallpapers;
};

const getThumbnail = (hash) => {
    return new Promise((resolve) => {
        let img = new Image();
        var canvas = document.createElement("canvas")
        var ctx = canvas.getContext('2d');
        img.onload = () => {
            canvas.width = 300;
            canvas.height = 300;
            ctx.drawImage(img, 0, 0, 300, 300);
            let arrayBuffer = dataURItoBlob(canvas.toDataURL());
            ipfs.addArrayBuffer(arrayBuffer)
                .then(resolve);
        };
        img.src = ipfs.getHashUrl(hash);
    });
};

function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    var arrayBuffer = new ArrayBuffer(byteString.length);
    var _ia = new Uint8Array(arrayBuffer);
    for (var i = 0; i < byteString.length; i++) {
        _ia[i] = byteString.charCodeAt(i);
    }
    return arrayBuffer
}

    
